// The business (courts, staff, customers) operates entirely out of the UAE, so
// "today" in the admin panel — the calendar's default selection, the "can't
// pick a past date" guard, report-range presets — must match the backend's
// Asia/Dubai day boundary, not the admin's own device/browser timezone.
//
// A Date object has no timezone of its own (it's just an instant), so getting
// this right means reading UAE's calendar fields directly via Intl rather
// than shifting an instant and reading it back with the browser's local
// getters (which would silently reintroduce the browser's own timezone).
const APP_TIMEZONE = 'Asia/Dubai';

const uaePartsFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});

// { year, month, day } for "now", as UAE sees it — independent of the
// browser's own timezone.
export function todayInUAEParts(instant = new Date()) {
    const parts = uaePartsFormatter.formatToParts(instant);
    const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    return { year: Number(map.year), month: Number(map.month), day: Number(map.day) };
}

// UAE "today" as "YYYY-MM-DD" — matches the date strings sent to the backend.
export function todayInUAEString(instant = new Date()) {
    const { year, month, day } = todayInUAEParts(instant);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

// UAE "today" at local midnight, as a Date constructed from local (browser)
// components equal to UAE's calendar fields. Any code that later reads this
// Date back with local getters (getFullYear/getMonth/getDate) — including
// react-datepicker — sees UAE's date, not the browser's.
export function todayInUAEDate(instant = new Date()) {
    const { year, month, day } = todayInUAEParts(instant);
    return new Date(year, month - 1, day);
}
